module.exports = {
  apiHost: "https://api.murdochwaters.sensoreal.app",
  assetsHost: "http://assets.murdochwaters.sensoreal.app",
  brandName: "Murdoch Waters",
  header: {
    text: { en: "YOUR MURDOCH WATER SELECTIONS" },
    logo:
      "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/murdochwaters/MW-Logo-White.png",
    companyLogo:
      "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/murdochwaters/intrapac-logo-mono.svg",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#243444",
    textColor: "#fff",
    font: "rajdhani",
    secondaryFont: "Krub",
    secondaryFontStylesheet:
      "https://fonts.googleapis.com/css2?family=Krub:wght@400;500;600;700&display=swap",
  },
  contact: {
    website: "https://murdochwaters.com.au",
    address: "Wangaratta, Victoria",
    phone: "+613 9207 8000", // intrapac vic office number for now
    email: "info@murdochwaters.com.au",
  },

  // intrapac links added for now, awaiting MW specific links
  links: {
    privacy: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/company/intrapacproperty/",
    twitter: "",
    instagram: "https://www.instagram.com/intrapacproperty/",
    facebook: "https://www.facebook.com/intrapacproperty/",
  },
  footerLogo: "",
};
